module.exports = __webpack_public_path__ + "static/media/streetlights.2cadce74.jpg";